// removeJoin — VQE-Edit edit-action: drop a JOIN clause by 0-based index via
// SR-Edit's `remove-join` op. Builds the StructuralEdit and delegates to
// `commitEdit`. Index validation against the supplied `QueryStructure`
// surfaces a friendlier error than SR-Edit's silent drop on out-of-range.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — add/remove JOIN +
// edit ON predicate.

import type { QueryStructure } from '../../../../sql-resolver/types/queryStructure';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

export type RemoveJoinOptions = {
  /**
   * Optional structure used for index-bounds validation. Lets the caller
   * surface a friendlier error than SR-Edit's silent drop.
   */
  readonly structure?: QueryStructure;
};

export async function removeJoin(
  index: number,
  ctx: CommitEditCtx,
  options: RemoveJoinOptions = {},
): Promise<void> {
  if (!Number.isInteger(index) || index < 0) {
    throw new Error(`removeJoin: index must be a non-negative integer (got ${index})`);
  }
  if (options.structure) {
    const joins = options.structure.joins ?? [];
    if (joins.length === 0) {
      throw new Error('removeJoin: JOIN list is empty');
    }
    if (index >= joins.length) {
      throw new Error(
        `removeJoin: index ${index} out of range (JOIN list has ${joins.length} item(s))`,
      );
    }
  }
  await commitEdit({ op: 'remove-join', index }, ctx);
}
